/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { GoogleProtobufDurationFromJSON, GoogleProtobufDurationToJSON, StreemApiArtifactCountsFromJSON, StreemApiArtifactCountsToJSON, StreemApiArtifactGpsPositionFromJSON, StreemApiArtifactGpsPositionToJSON, StreemApiCallLogParticipantFromJSON, StreemApiCallLogParticipantToJSON, StreemApiCallLogRoomInvitationFromJSON, StreemApiCallLogRoomInvitationToJSON, StreemApiNoteFromJSON, StreemApiNoteToJSON, } from './';
export function StreemApiCallLogEntryFromJSON(json) {
    return StreemApiCallLogEntryFromJSONTyped(json, false);
}
export function StreemApiCallLogEntryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'roomSid': !exists(json, 'room_sid') ? undefined : json['room_sid'],
        'startTime': !exists(json, 'start_time') ? undefined : (new Date(json['start_time'])),
        'endTime': !exists(json, 'end_time') ? undefined : (new Date(json['end_time'])),
        'participants': !exists(json, 'participants') ? undefined : (json['participants'].map(StreemApiCallLogParticipantFromJSON)),
        'missed': !exists(json, 'missed') ? undefined : json['missed'],
        'onsite': !exists(json, 'onsite') ? undefined : json['onsite'],
        'artifactCounts': !exists(json, 'artifact_counts') ? undefined : StreemApiArtifactCountsFromJSON(json['artifact_counts']),
        'shareUrl': !exists(json, 'share_url') ? undefined : json['share_url'],
        'referenceId': !exists(json, 'reference_id') ? undefined : json['reference_id'],
        'createdByUserSid': !exists(json, 'created_by_user_sid') ? undefined : json['created_by_user_sid'],
        'note': !exists(json, 'note') ? undefined : StreemApiNoteFromJSON(json['note']),
        'latestGpsPosition': !exists(json, 'latest_gps_position') ? undefined : StreemApiArtifactGpsPositionFromJSON(json['latest_gps_position']),
        'invitations': !exists(json, 'invitations') ? undefined : (json['invitations'].map(StreemApiCallLogRoomInvitationFromJSON)),
        'favorite': !exists(json, 'favorite') ? undefined : json['favorite'],
        'integrationId': !exists(json, 'integration_id') ? undefined : json['integration_id'],
        'callStatus': !exists(json, 'call_status') ? undefined : json['call_status'],
        'canceledCallRingTimeInSecs': !exists(json, 'canceled_call_ring_time_in_secs') ? undefined : json['canceled_call_ring_time_in_secs'],
        'callDuration': !exists(json, 'call_duration') ? undefined : GoogleProtobufDurationFromJSON(json['call_duration']),
        'transferred': !exists(json, 'transferred') ? undefined : json['transferred'],
        'requeued': !exists(json, 'requeued') ? undefined : json['requeued'],
    };
}
export function StreemApiCallLogEntryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'room_sid': value.roomSid,
        'start_time': value.startTime === undefined ? undefined : (value.startTime.toISOString()),
        'end_time': value.endTime === undefined ? undefined : (value.endTime.toISOString()),
        'participants': value.participants === undefined ? undefined : (value.participants.map(StreemApiCallLogParticipantToJSON)),
        'missed': value.missed,
        'onsite': value.onsite,
        'artifact_counts': StreemApiArtifactCountsToJSON(value.artifactCounts),
        'share_url': value.shareUrl,
        'reference_id': value.referenceId,
        'created_by_user_sid': value.createdByUserSid,
        'note': StreemApiNoteToJSON(value.note),
        'latest_gps_position': StreemApiArtifactGpsPositionToJSON(value.latestGpsPosition),
        'invitations': value.invitations === undefined ? undefined : (value.invitations.map(StreemApiCallLogRoomInvitationToJSON)),
        'favorite': value.favorite,
        'integration_id': value.integrationId,
        'call_status': value.callStatus,
        'canceled_call_ring_time_in_secs': value.canceledCallRingTimeInSecs,
        'call_duration': GoogleProtobufDurationToJSON(value.callDuration),
        'transferred': value.transferred,
        'requeued': value.requeued,
    };
}
/**
* @export
* @enum {string}
*/
export var StreemApiCallLogEntryCallStatus;
(function (StreemApiCallLogEntryCallStatus) {
    StreemApiCallLogEntryCallStatus["CANCELED"] = "STATUS_CANCELED";
    StreemApiCallLogEntryCallStatus["INVALID"] = "STATUS_INVALID";
    StreemApiCallLogEntryCallStatus["REJECTED"] = "STATUS_REJECTED";
    StreemApiCallLogEntryCallStatus["SUCCESSFUL"] = "STATUS_SUCCESSFUL";
    StreemApiCallLogEntryCallStatus["TIMEDOUT"] = "STATUS_TIMED_OUT";
})(StreemApiCallLogEntryCallStatus || (StreemApiCallLogEntryCallStatus = {}));
//# sourceMappingURL=StreemApiCallLogEntry.js.map